import { Box, Fab, Typography } from "@mui/material"

import clock from "static/images/statuses/clocks_light.png"
import { ReactComponent as Doctor } from "static/svg/navigation/doctor.svg"

import useAppStore from "store/app"
import useTranslation from "../../hooks/use_translation"

const NoClientData = (props) => {
  const { description } = props
  const { first_name } = useAppStore((state) => state.user)

  const { pages } = useTranslation()
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        component="img"
        alt="Image"
        src={clock}
        sx={{ maxHeight: 200, maxWidth: 250, mt: 7, alignSelf: "center", mb: -4 }}
      />
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2.5 }}>
        {pages?.client_main?.hi}, {first_name}!
      </Typography>
      <Typography sx={{ mb: 2.5 }}>{description}</Typography>
      <Typography sx={{ fontWeight: 600 }}>{pages?.client_main?.push_red_btn}</Typography>

      <Fab
        color="secondary"
        aria-label="start bot"
        sx={{
          width: 60,
          height: 60,
          mt: 2,
          opacity: 0.3,
        }}
      >
        <Doctor sx={{ color: "secondary.main" }} />
      </Fab>
    </Box>
  )
}

export default NoClientData
